export const Events = {
    SELECT_POI: 'POI_SELECTED',
    PHONE_CLICK: 'PHONE_CLICKED',
    WEBSITE_CLICK: 'WEBSITE_CLICKED',
    AUTOCOMPLETE: 'AUTOCOMPLETE',
    SEARCH_RESULT_SELECTED: 'SEARCH_RESULT_ITEM_SELECTED',
    SELECT_DIRECTION: 'FIND_ROUTE',
    NAVIGATION_CLICK: 'NAVIGATION_STARTED',
    ITINERARY_MODE_EXITED: 'ITINERARY_MODE_EXITED'
};
